export const StoreNames = Object.freeze({
  OPERATORS: 'operators',
  TOURS: 'tours',
  SPECIES: 'species',
  TRIPS: 'trips',
  USERS: 'users',
  PROJECTS: 'projects',
});

export const Stores = [
  {
    name: StoreNames.OPERATORS,
    indexes: [],
  },
  {
    name: StoreNames.TOURS,
    indexes: [],
  },
  {
    name: StoreNames.SPECIES,
    indexes: ['created_at'],
  },
  {
    name: StoreNames.TRIPS,
    indexes: ['created_at'],
  },
  {
    name: StoreNames.USERS,
    indexes: [],
  },
  {
    name: StoreNames.PROJECTS,
    indexes: [],
  },
];
